import { render, staticRenderFns } from "./AccountUpdateHealthQuestions.vue?vue&type=template&id=4acb51d7&scoped=true&"
import script from "./AccountUpdateHealthQuestions.vue?vue&type=script&lang=js&"
export * from "./AccountUpdateHealthQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb51d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acb51d7')) {
      api.createRecord('4acb51d7', component.options)
    } else {
      api.reload('4acb51d7', component.options)
    }
    module.hot.accept("./AccountUpdateHealthQuestions.vue?vue&type=template&id=4acb51d7&scoped=true&", function () {
      api.rerender('4acb51d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Account/Children/AccountUpdateHealthQuestions.vue"
export default component.exports